<template>
  <div class="container">
    <!-- {{ isInited }} -->
    <van-list
      v-model:loading="state.loading"
      :finished="state.finished"
      finished-text="没有更多了"
      @load="onLoad"
      style="min-height: 400px"
    >
      <van-cell
        v-for="item in listData"
        :key="item"
        title-class="title-item"
        :to="`/detail?id=${item.id}&type=${state.params.type}`"
      >
        <template #title>
          <div class="item-list">
            <span class="item-time">{{ moment(item.created_time).format('YYYY/MM/DD') }}</span>
            <p>{{ item.title }}</p>
          </div>
        </template>
      </van-cell>
    </van-list>
  </div>
</template>
<script>
import moment from 'moment';
import { List, Cell } from 'vant';
import { reactive, ref } from 'vue';
import { getreport } from './helper/api';
import { urlUtil } from '@/utils';

export default {
  name: 'NewsList',
  components: {
    'van-list': List,
    'van-cell': Cell
  },
  setup() {
    const { type = 5, page = 1 } = urlUtil.parseQuery();
    let listData = ref([]);
    let isInited = ref(false);
    let state = reactive({
      loading: false,
      finished: false,
      params: {
        page,
        size: 10,
        type,
        total: 0
      }
    });
    const { params } = state;
    const onLoad = () => {
      const { page, size, type } = params;
      getreport({ page, size, type })
        .then(res => {
          let { list, count } = res;
          listData.value.push(...list);
          state.params.total = count;
          // 加载状态结束
          state.loading = false;

          if (count <= page * size) {
            state.finished = true;
          } else {
            state.params.page += 1;
          }
        })
        .catch(err => {
          console.error(err);
          state.loading = false;
        });
    };
    if (!isInited.value) {
      isInited = true;
    }
    return {
      listData,
      onLoad,
      state,
      moment
    };
  },
  watch: {
    $route(newVal, oldVal) {
      // console.log(newVal, oldVal, newVal !== oldVal);
      if (newVal !== oldVal && newVal.path === '/newslist') {
        const { page = 1, type = 1 } = newVal.query;
        this.listData.length = 0;
        this.state.finished = false;
        Object.assign(this.state.params, { page, type, total: 0 });
        // 切换路由后手动控制加载，自动控制的时候会发现有时候切换tab它不会加载数据
        this.state.loading = true;
        this.onLoad();
      }
    }
  }
};
</script>

<style lang="scss">
@import './style/config';
.van-cell {
  cursor: pointer;
}
.title-item {
  width: 100%;
}
.item-list {
  width: 100%;
  p {
    height: 40px;
    line-height: 40px;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    white-space: nowrap;
    word-wrap: break-word;
  }
}
.item-time {
  float: right;
  display: block;
  width: 200px;
  color: #999;
  text-align: right;
}
</style>
